import { useMemo } from "react";
import { validator } from "@/utils/validator";
import { MAX_CHARACTER_INPUT_VALIDATION, MAX_TEXT_INPUT_VALIDATION } from "@/constants/common";
import { TFilter } from "@/api/services/main/case/dtos/create-case.dto";

export const useCaseSchema = () => {
  const caseSchema = useMemo(() => {
    return validator.object().shape({
      name: validator.string().trim().label("案件名").max(MAX_CHARACTER_INPUT_VALIDATION).required(),
      managementNumber: validator
        .string()
        .trim()
        .label("案件管理番号")
        .required()
        .test("six-digit-number", "「案件管理番号」は6桁の数字で入力してください。", function (value) {
          if (!value) return true;
          const regex = /^\d{6}$/;
          return regex.test(value);
        }),
      personInChargeId: validator.number().isSelection().label("案件担当者").required(),
      // emptyToNull tags the field meta `isEmptyToNull`, which makes the shared Textarea run
      // sanitizeInput() on blur (collapse consecutive/full-width spaces, etc.) and empty → null.
      memo: validator.string().trim().emptyToNull().label("案件メモ").max(MAX_TEXT_INPUT_VALIDATION).notRequired(),
      talentFilter: validator.mixed<TFilter>().required(),
    });
  }, []);

  return { caseSchema };
};
